import { defaultTheme } from './default';

export const darkTheme = {
  ...defaultTheme,
  isDark: true,
  colors: {
    ...defaultTheme.colors,
    grayBackground: '#0D0F11',
    white: '#191D23',
    menuBackground: '#191D23',
    grayExtraLight: '#4B506D',
    grayDark: '#E3E3E3',
    gray: '#E3E3E3',
    grayLight: '#B8C0CC',
    grayDivider: '#B8C0CC',
    grayDividerGraph: '#9FA2B4',
    grayLightest: '#9FA2B4',
    lightBlack: '#B8C0CC',
    black: '#FFF',
    accentLight: '#3E4FD5',
    accentHover: '#6F79E3',
    accent: '#9DA2EC',
    red: '#FF405D',
    green: '#00AE6E',
    saturatedBlue: '#99C3FF',
    yellow: '#FFC63D',

    primaryDisabled: '#642ADB',
    accentDisabled: '#383B53',

    // custom colors
    textAccent: '#FFF',
    actionSurface: '#4B506D',
    iconHover: '#3E4FD5',
    primaryAction: '#3E4FD5',
    inactiveText: '#FFFFFF',
    inactiveSurface: '#4B506D',
    secondaryPressedBg: '#3E4FD5',
    disabledSurface: '#0D0F11',
    disabledText: '#4E5058',
    filterBg: '#4B506D',
    filterText: '#FFFFFF',
    filterActiveText: '#3E4FD5',
    filterDisabledText: '#E3E3E3',
    dropdownDisabledText: '#FFFFFF',
    bannerBackground: '#252733',
    sidebarLabel: '#FFFFFF',
    sidebarHover: '#191D23',
    sidebarSelected: '#0D0F11',
    sidebarBackground: '#252733',
    calendarSelectedText: '#4B506D',
    dateBgHover: '#0D0F11',
    modalOverlay: '#0D0F11CC',
    lavenderLightest: '#43205B',
    linkText: '#99C3FF'
  }
};
